<template>
  <v-container>
    <!-- BOC:[breadcrumbs] -->
    <ABreadcrumb :items="breadcrumbs"></ABreadcrumb>
    <!-- EOC -->
    <!-- BOC:[error] -->
    <AError
      v-if="api.isError"
      :api="api"
      :callbackReset="() => (api.isError = false)"
    ></AError>
    <!-- EOC -->
    <v-card class="mx-auto pa-3" max-width="800" outlined min-height="200">
      <v-row>
        <v-col><h2>Remove Mission</h2></v-col>
      </v-row>
      <v-card-title></v-card-title>
      <div class="d-flex align-center justify-space-around">
        <div class="form-content text-center">
          <v-alert border="bottom" colored-border type="error" elevation="2">
            This action is irreversible. Are you sure you want to remove
            <b v-if="name">{{ name }}</b
            >?
          </v-alert>
          <div class="text-right">
            <v-btn color="error" class="mr-4" @click="submit" text> Yes </v-btn>
            <v-btn text @click="$router.go(-1)"> No </v-btn>
          </div>
        </div>
      </div>
    </v-card>
  </v-container>
</template>
    
    <script>
import { mapState } from "vuex";
export default {
  components: {
    //
  },
  computed: {
    size() {
      const size = { xs: "small", sm: "small", lg: "large", xl: "x-large" }[
        this.$vuetify.breakpoint.name
      ];
      return size ? { [size]: true } : {};
    },
    ...mapState({
      auth: (state) => state.auth.data,
    }),
  },
  // computed: mapState({
  //     auth: (state) => state.auth.data,
  //   }),
  props: [
    //
  ],
  data: () => ({
    //BOC:[breadcrumbs]
    breadcrumbs: [],
    //EOC
    //BOC:[api]
    api: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    //EOC
    //BOC:[api]
    deleteApi: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    //EOC
    name: null,
  }),
  created() {

    this.api.method = "GET";
    this.api.url =
      this.$api.servers.game +
      "/api/v1/" +
      this.$_getLocale() +
      "/backend/player/" +
      this.$route.params.parentId +
      "/mission/" +
      this.$route.params.id;

    this.api.callbackReset = () => {
      this.api.isLoading = true;
      this.api.isError = false;
    };

    this.api.callbackError = (e) => {
      this.api.isLoading = false;
      this.api.isError = true;
      this.api.error = e;
    };

    this.api.callbackSuccess = () => {
      this.api.isLoading = false;
      this.updateBreadcrumb()
    };
    this.deleteApi.url =
    this.$api.servers.game +
      "/api/v1/" +
      this.$_getLocale() +
      "/backend/player/" +
      this.$route.params.parentId +
      "/mission/delete";

    this.deleteApi.callbackReset = () => {
      this.deleteApi.isLoading = true;
      this.deleteApi.isError = false;
    };

    this.deleteApi.callbackError = (e) => {
      this.deleteApi.isLoading = false;
      this.deleteApi.isError = true;
      this.deleteApi.error = e;
    };

    this.deleteApi.callbackSuccess = () => {
      this.deleteApi.isLoading = false;
      this.$router.push({ name: 'PageFamilyUserRead', params: { id:  this.$route.params.parentId } });
    };
  },
  mounted() {
    this.$api.fetch(this.api);
  },
  methods: {
    updateBreadcrumb() {
      this.breadcrumbs.push({
        text: "Dashboard",
        to: { name: "PageFamilyDashboard" },
        exact: true,
      });
      this.breadcrumbs.push({
        text: 'User Info',
        to: { name: "PageFamilyUserRead",params:{id:this.$route.params.parentId} },
        exact: true,
      });
     
    this.breadcrumbs.push({
      text: "Mission Info",
      to: { name: "PageFamilyUserMissionRead" ,params:{id:this.$route.params.id,parentId:this.$route.params.parentId} },
      exact: true,
    });

    this.breadcrumbs.push({
      text: "Remove",
      to: { name: "PageFamilyUserMissionRemove" },
      exact: true,
    });
    },
    submit() {
      this.deleteApi.params = {
        id: this.$route.params.id,
      };
      this.$api.fetch(this.deleteApi);
    },
  },
};
</script>
<style scoped>
.menu-item {
  border: 1px solid black;
  margin: 3px;
}
.form-content {
  width: 600px !important;
}
</style>